import { IconButton, Tooltip } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

interface Props {
  // アイコンの読み上げ名（「役員名の説明」）に使う欄名。
  label: string;
  hint: string;
}

/**
 * 欄の説明をツールチップで出す「？」。説明が無いと意味の分からない欄（照合の決まりなど）にだけ置く。
 * 見れば分かること（複数選べる・空欄は制限なし など）には置かない。
 * スマートフォンでもタップですぐ開くよう、タッチの待ち時間を 0 にする。
 * アイコンだけのボタンは 40px 四方にする（small のアイコンと既定の余白だけでは 36px になる）。
 */
export const HintIcon: React.FC<Props> = ({ label, hint }) => (
  <Tooltip
    title={hint}
    placement="top"
    arrow
    describeChild
    enterTouchDelay={0}
    leaveTouchDelay={5000}
  >
    <IconButton
      aria-label={`${label}の説明`}
      edge="end"
      sx={{ width: 40, height: 40 }}
    >
      <HelpOutlineIcon fontSize="small" />
    </IconButton>
  </Tooltip>
);
